import {httpRequest} from "../../../utils/HttpRequest";
import {IKey, IMdCmFields, IPage, ISearchPageField} from "../../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";


export interface IMdSettingFields extends IMdCmFields {
    code?: string;
    name?: string;
    value?: string;
    note?: string;
    status?: number;


}

export type IMdSettingDetail = IKey & IMdCmFields & IMdSettingFields;
export type IMdSettingSearch = IMdSettingFields & ISearchPageField;

class SettingService {
    async insert(insertVo: IMdSettingFields) {
        const apiUrl = "/setting/insert";
        return await httpRequest.post<IMdSettingDetail>(apiUrl, insertVo);
    }

    async update(updateVo: IMdSettingFields) {
        const apiUrl = "/setting/update";
        return await httpRequest.post<IMdSettingDetail>(apiUrl, updateVo);
    }

    async disable(oneVo: IMdSettingFields) {
        const apiUrl = "/setting/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo);
    }

    async find(searchVo: IMdSettingFields) {
        const apiUrl = "/setting/find";
        return await httpRequest.post<IMdSettingDetail[]>(apiUrl, searchVo);
    }

    async page(searchVo: IMdSettingSearch) {
        const apiUrl = "/setting/page";
        return await httpRequest.post<IPage<IMdSettingDetail>>(apiUrl, searchVo);
    }

    async one(oneVo: IMdSettingFields) {
        const apiUrl = "/setting/one";
        return await httpRequest.post<IMdSettingDetail>(apiUrl, oneVo);
    }

    async sync(syncVo: IMdSettingFields) {
        const appPageUrl = "/setting/sync";
        syncVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, syncVo,{ timeout: LONG_REQUEST_TIMEOUT });
    }

    async syncPage(searchVo: IMdSettingSearch) {
        const appPageUrl = "/setting/syncPage";
        searchVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdSettingFields) {
        const appPageUrl = "/setting/syncPage";

        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }
}

export const settingService = new SettingService();
